const initialState = {
  auth: {
    step: 'sign-in',
    username: '',
    password: '',
    continuationUsername: '',
    continuationPassword: '',
    selectedMFA: null,
    mfaOptions: [],
    otp: '',
    isLoading: false,
    isAuthorizeFlow: false,
    isAuthenticated: false,
    tokenId: null,
    error: null,
    fieldErrors: {},
    lockoutModalOpen: false,
    authenticatePayload: null,
    serverErrorModalOpen: false,
    uniqueIdentifier: null,
    appName: null,
    authorizeResponse: null,
    clientId: '',
    agencyId: '',
    customerAppId: '',
    userAliasId: null,
    appUrl: null,
    userDetails: {
      firstname: '',
      lastname: '',
      address: '',
      userEmail: '',
    },
    hasExistingSession: false,
    authType: null,
    goToUrl: null,
    scope: '',
    utmParams: {
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
    },
  },
  language: {
    selected: localStorage.getItem('i18nextLng') || 'en',
    options: [
      {
        label: 'English',
        value: 'ENG',
        code: 'en',
      },
      {
        label: 'Español',
        value: 'ESP',
        code: 'es',
      },
    ],
  },
};
export default initialState;